<script lang="ts">
	import Avatar from '$lib/components/Avatar/Avatar.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import {
		isComposerOpen,
		isGeneratingPost,
		composerInitBlock,
		unsetComposerStores,
		composerPost as post,
	} from '$lib/components/TextEditor/PostComposer/composerStore';
	import TextEditor from '$lib/components/TextEditor/TextEditor.svelte';
	import type { Readable } from 'svelte/store';
	import type { Editor } from 'svelte-tiptap';
	import { onDestroy, onMount } from 'svelte';
	import { postToTipTapSchema } from '$textEditor/utils/postToSchema';
	import type { JSONContent } from '@tiptap/core';
	import InitBlock from '$textEditor/PostComposer/InitBlock.svelte';
	import type { Post } from '$lib/api/rpc';
	import Footer from './Footer.svelte';
	import PostLoadingSkeleton from './PostLoadingSkeleton.svelte';
	import Modal from '$lib/components/Modal/Modal.svelte';
	import Size from '$lib/components/Modal/size';
	import { _ } from 'svelte-i18n';
	const getCloseMessage = () => {
		if ($post.status == undefined) return $_('compose.are.you.sure.exit');
		return $_('hubs.newsletters.exit.confirm.message');
	};
	const { user } = getHubStores();

	let editor: Readable<Editor>;
	let content: JSONContent;

	onMount(() => {
		if ($post.id) {
			content = postToTipTapSchema($post as Post);
		}
		setTimeout(() => {
			if (content) $editor.commands.setContent(content);
			$editor.commands.focus('start');
		});
	});

	onDestroy(() => unsetComposerStores());
</script>

<Modal
	onClose={() => {
		$isComposerOpen = false;
	}}
	isOpen={true}
	type={Size.Auto}
	confirmationOnClose={getCloseMessage()}>
	<div slot="content" class="composer">
		<div class="userTop">
			<Avatar url={$user.avatar_url} name={$user.name} />
			<h3>{$user.name}</h3>
		</div>
		<span id="label">{$_('common.what.do.you.want.to.share')}</span>
		{#if !$isGeneratingPost}
			<main class="editor scroll" aria-labelledby="label">
				<TextEditor bind:editor />
			</main>
		{:else}
			<PostLoadingSkeleton />
		{/if}
		<Footer {post} {editor} />

		{#if $composerInitBlock}
			<InitBlock {editor} />
		{/if}
	</div>
</Modal>

<style>
	.composer {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: start;
		block-size: 80vh;
		inline-size: 80vw;
	}

	.userTop {
		display: flex;
		align-items: center;
		justify-content: start;
		block-size: 50px;
		inline-size: 80%;
		margin-inline: auto;
	}

	.userTop h3 {
		margin-inline-start: var(--gutterSmall);
		color: black;
	}

	#label {
		inline-size: 80%;
		color: var(--grayDark);
		font-style: italic;
	}

	.editor {
		flex: 1;
		inline-size: 85%;
	}

	@media screen and (max-width: 575px) {
		.composer {
			block-size: 95vh;
		}
	}
</style>
